import { useEffect } from "react";
import { useUnifiedTier } from "@/lib/ageCopy";

/** Mirrors the active tier onto <html data-tier> so CSS tokens can mature the UI by age. */
export default function TierAttribute() {
  const tier = useUnifiedTier();
  useEffect(() => {
    try { document.documentElement.dataset.tier = tier || "explorers"; } catch { /* SSR */ }
  }, [tier]);
  return null;
}
